import { render, staticRenderFns } from "./Method.vue?vue&type=template&id=27968caa&scoped=true"
import script from "./Method.vue?vue&type=script&lang=js"
export * from "./Method.vue?vue&type=script&lang=js"
import style0 from "./Method.vue?vue&type=style&index=0&id=27968caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27968caa",
  null
  
)

export default component.exports